<!-- 人才招募 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_team.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="招贤纳士" en="RECRUIT THE RIGHT PERSON"></sub-title>
        <div class="list">
          <div
            :class="{ item: true, warning: item.helpWantedFlag == 1 }"
            v-for="item in list"
            :key="item.id"
            @click="item.expand = !item.expand"
          >
            <div class="box">
              <div class="left">
                <span>{{ item.jobName }} ----- {{ item.jobNum }}名</span>
                <span v-show="item.helpWantedFlag == 1">（急）</span>
              </div>
              <div class="btn">
                <i class="el-icon-plus" v-show="!item.expand"></i>
                <i class="el-icon-minus" v-show="item.expand"></i>
              </div>
            </div>
            <div class="detail" v-show="item.expand">
              {{ item.dutyContent }}
            </div>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.pageIndex"
            :page-size="queryParams.pageSize"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
import { URL } from "@/util/config";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      URL,
      routerHistory: [], // 当前所在位置
      subNavs: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
      },
      list: [],
      total: 0,
      bannerList: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.getList();
    this.formatBreadCrumb();
  },
  mounted() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      let res = await this.$api.getBannerList({ type: 2 });
      this.bannerList = res.data;
      setTimeout(() => {
        this.initBannerSwiper();
      }, 10);
    },
    // 初始化banner swiper
    initBannerSwiper() {
      new window.Swiper("#banner", {
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    },
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
    async getList() {
      let res = await this.$api.getJobList(this.queryParams);
      this.list = res.data.list.map((ele) => {
        ele.expand = false;
        return ele;
      });
      this.total = res.data.total;
    },
    handleCurrentChange(val) {
      this.queryParams.pageIndex = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 30px;

    .list {
      margin: 50px 0 120px;

      .item {
        margin-bottom: 30px;

        .box {
          height: 70px;
          background-color: $theme;
          border: 1px solid #9a9a9a;
          padding: 0 40px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #fff;
          font-size: 20px;
          cursor: pointer;

          .btn {
            font-size: 20px;
            margin-left: 10px;
          }
        }
        .detail {
          background-color: rgba(160, 27, 27, 0.04);
          padding: 20px 40px;
          box-sizing: border-box;
          white-space: pre-wrap;
          line-height: 1.82;
        }
      }
      .warning .box {
        background-color: #a01b1b;
      }
    }
  }
}
@media (max-width: 1400px) {
  .frame #banner {
    height: 600px;
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .list {
        margin: 20px 0;

        .item {
          margin-bottom: 20px;

          .box {
            height: auto;
            min-height: 50px;
            padding: 0 20px;
            font-size: 16px;
          }
          .detail {
            padding: 20px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
